import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { Outlet, useNavigate } from "react-router-dom";

import { attachAuthClient } from "../api/api";
import config from "../config";

const oktaAuth = new OktaAuth(config.oidc);

attachAuthClient(oktaAuth);

export const AuthWrapper = () => {
  const navigate = useNavigate();
  const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  const onAuthRequired = async () => {
    await oktaAuth.signInWithRedirect();
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={onAuthRequired}>
      <Outlet />
    </Security>
  );
};
